import { queryKeys } from '@query/keys'
import { PaginatedQueryResult, usePaginatedQuery } from '@query/usePaginatedQuery'

import { useAccountReadContext } from '@context/AccountContextContext'
import { useSessionLanguage } from '@context/SessionSettingsContext'

import { useApiClient } from '@utils/ApiClient'
import { ClientApiClient } from '@utils/clientApi'

import { AccountSummaryDto } from '@model/AccountSummaryDto'

import { SearchResponseProps } from '../../IBReportResultsPage'

interface AccountSummaryFetchProps {
  search: SearchResponseProps
}

export const IB_CLIENTS_REPORTS_SEARCH_TERM = 'ca_search_TextSearch'

export const useAccountSummaryFetch = (
  props: AccountSummaryFetchProps
): {
  query: PaginatedQueryResult<AccountSummaryDto>
} => {
  const { search } = props

  const locale = useSessionLanguage()
  const apiClient = useApiClient(ClientApiClient)
  const { account } = useAccountReadContext()

  const ibId = account?.clientIntroducingBroker?.id

  const searchKey = {
    ...search.search,
    ca_search_TextSearch: search.debouncedSearchTerm,
    locale,
  }

  const query = usePaginatedQuery({
    queryKey: queryKeys.ib.clientsPerAccountSummary(ibId, searchKey, locale),
    queryFn: (pageQuery) =>
      apiClient.getIntroducingBrokerIncomeSummaryPerAccount(ibId ?? '', {
        ...pageQuery,
        search: { ...search.search, [IB_CLIENTS_REPORTS_SEARCH_TERM]: search.debouncedSearchTerm },
        sort: pageQuery?.sort,
        sortOrder: pageQuery?.sortOrder,
        caller: 'ca',
        languageId: locale,
      }),
  })

  return { query }
}
